module.exports = __webpack_public_path__ + "images/emoji/baby_bottle.d1e78386bad9ac434f9c.png";